export default __webpack_public_path__ + "assets/images/onboarding/b5c24c1f39c3f56eb21180f3ab55cea4.mp4";